import { FaUserSecret } from "react-icons/fa"

// ============================================
// COMMON MENU ITEMS (Reusable)
// ============================================

const DASHBOARD = {
  routeLink: "/#",
  icon: "bx bx-home-circle",
  title: "Dashboard",
  isStore: true,
}

const SALES_LEADS = {
  routeLink: "/lead/sales",
  icon: "bx bx-cart-alt",
  title: "Sales Leads",
  name: "sales",
}

const PURCHASE_LEADS = {
  routeLink: "/lead/purchase",
  icon: "bx bx-basket",
  title: "Purchase Leads",
  name: "purchase",
}

const INVESTMENT_LEADS = {
  routeLink: "/investment/leads/all",
  icon: "bx bx-chart",
  title: "Investment Leads",
  isStore: true,
}

const FOLLOWUP_TASKS = {
  routeLink: "/followUp/all",
  icon: "bx bxs-bell-ring",
  title: "FollowUp Tasks",
  isStore: true,
}

const MATCHING_LIST = {
  routeLink: "/matching-list/all",
  icon: "bx bx-list-check",
  title: "Matching List",
  isStore: true,
}

const VEHICLES = {
  routeLink: "/vehicle/all",
  icon: "bx bx-car",
  title: "Vehicles",
  isStore: true,
}

const SPECIFICATIONS = {
  routeLink: "/category",
  icon: "bx bx-detail ",
  title: "Specifications",
}

const CATEGORIES = {
  routeLink: "/categories",
  icon: "bx bxs-color-fill",
  title: "Categories",
}

const BRANCHES = {
  routeLink: "/branch/all",
  icon: "bx bxs-store-alt",
  title: "Branches",
  isStore: true,
}

const SALE_ENTRY = {
  routeLink: "/sale/all",
  icon: "bx bx-cart",
  title: "Sale Entry",
  isStore: true,
}

const CLIENTS = {
  routeLink: "/client/all",
  icon: "bx bx-user",
  title: "Clients",
  isStore: true,
}

const STAFFS = {
  routeLink: "/member/all",
  icon: "bx bxs-user",
  title: "Staffs",
}

const CHALLAN_LIST = {
  routeLink: "/challan-list/all",
  icon: "bx bx-receipt",
  title: "Challan List",
  isStore: true,
}

const TESTIMONIAL = {
  routeLink: "/testimonial/all",
  icon: "bx bx-user-voice",
  title: "Testimonial",
  isStore: true,
}

const YOUTUBE = {
  routeLink: "/youtube-video/all",
  icon: "bx bxl-youtube",
  title: "Youtube",
  isStore: true,
}

const SHORTS = {
  routeLink: "/youtube-short-video/all",
  icon: "bx bx-slideshow",
  title: "Shorts",
  isStore: true,
}

const CAR_DELIVERY = {
  routeLink: "/car-delivery/all",
  icon: "bx bx-photo-album",
  title: "Car Delivery",
  isStore: true,
}

const SHOWROOM = {
  routeLink: "/showroom/all",
  icon: "bx bx-building-house",
  title: "Showroom",
  isStore: true,
}

const BANNER = {
  routeLink: "/banner/all",
  icon: "bx bx-windows",
  title: "Banner",
  isStore: true,
}

const INSPECTION = {
  routeLink: "/inspection/all",
  icon: FaUserSecret,
  title: "Inspect",
  isStore: true,
}

const INSPECTION_BOOKING = {
  routeLink: "/inspection-booking/all",
  icon: "bx bxs-book-content",
  title: "Booking",
  isStore: true,
}

const PROFILE = {
  routeLink: "?profile",
  icon: "bx bx-user",
  title: "Profile",
  isStore: true,
}

// ============================================
// SEPARATORS
// ============================================

const SEPARATOR_LEADS = {
  routeLink: "/#",
  icon: "",
  title: "Leads",
  isSeparator: true,
}

const SEPARATOR_INSPECTION = {
  routeLink: "/#",
  icon: "",
  title: "INSPECTION",
  isSeparator: true,
}

const SEPARATOR_GARAGE = {
  routeLink: "/#",
  icon: "",
  title: "Garage",
  isSeparator: true,
}

const SEPARATOR_ADMINISTRATION = {
  routeLink: "/#",
  icon: "",
  title: "Administration",
  isSeparator: true,
}

const SEPARATOR_SITE_SETTINGS = {
  routeLink: "/#",
  icon: "",
  title: "Site Settings",
  isSeparator: true,
}

const SEPARATOR_EXTRAS = {
  routeLink: "/#",
  icon: "",
  title: "Extras",
  isSeparator: true,
}

// ============================================
// SIDEBAR DATA EXPORTS
// ============================================

export const headQuartersSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  INVESTMENT_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_INSPECTION,
  INSPECTION,
  INSPECTION_BOOKING,
  CHALLAN_LIST,
  SEPARATOR_GARAGE,
  VEHICLES,
  SPECIFICATIONS,
  CATEGORIES,
  SEPARATOR_ADMINISTRATION,
  BRANCHES,
  SALE_ENTRY,
  CLIENTS,
  STAFFS,
  SEPARATOR_SITE_SETTINGS,
  TESTIMONIAL,
  YOUTUBE,
  SHORTS,
  CAR_DELIVERY,
  SHOWROOM,
  BANNER,
]

export const branchAdminSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  MATCHING_LIST,
  SEPARATOR_GARAGE,
  VEHICLES,
  SPECIFICATIONS,
  CATEGORIES,
  SEPARATOR_ADMINISTRATION,
  SALE_ENTRY,
  CLIENTS,
  STAFFS,
]

export const managingDirectorSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
  SEPARATOR_ADMINISTRATION,
  CLIENTS,
  SEPARATOR_EXTRAS,
]

export const generalManagerSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
  SEPARATOR_ADMINISTRATION,
  CLIENTS,
  SEPARATOR_EXTRAS,
]

export const enquiryManagerSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
  SEPARATOR_ADMINISTRATION,
  CLIENTS,
]

export const enquiryAnalystSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
]

export const salesExecutiveSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
  SEPARATOR_ADMINISTRATION,
  CLIENTS,
]

export const salesManagerSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
  SEPARATOR_ADMINISTRATION,
  CLIENTS,
]

export const branchManagerSidebarData = [
  DASHBOARD,
  SEPARATOR_LEADS,
  SALES_LEADS,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS,
  SEPARATOR_GARAGE,
  VEHICLES,
]

export const purchaseManagerSidebarData = [
  DASHBOARD,
  VEHICLES,
  PURCHASE_LEADS,
  FOLLOWUP_TASKS
]

export const purchaseInspectionUserSidebarData = [
  DASHBOARD,
  {
    routeLink: "/inspection/all",
    icon: "mdi-database-search-outline",
    title: "Inspection",
    isStore: true,
  },
  INSPECTION_BOOKING,
  FOLLOWUP_TASKS,
]

export const businessDevelopmentOfficerSidebarData = [
  INVESTMENT_LEADS,
  FOLLOWUP_TASKS,
  PROFILE,
]

export const teamMemberSidebarData = [
  DASHBOARD,
  FOLLOWUP_TASKS,
  PROFILE,
]